document.addEventListener('change', function(e) {
  const select = e.target.closest('select');
  if (!select) return;

  const form = select.closest('form');
  if (!form) return;

  const productHandle = window.location.pathname.split('/products/')[1];
  if (!productHandle) return;

  const variantId = select.value;

  fetch('/products/' + productHandle + '.js')
    .then(r => r.json())
    .then(product => {
      const variant = product.variants.find(v => String(v.id) === String(variantId));
      if (!variant || !variant.featured_image) return;

      const src = variant.featured_image.src;

      document.querySelectorAll('img').forEach(img => {
        if (img.src && img.src.includes('cdn.shopify.com/s/files')) {
          img.src = src;
          img.srcset = src;
        }
      });
    });
});